import DeleteUserForm from './DeleteUserForm';

export default DeleteUserForm;
